import type { BrandConfig } from '../types';

/** ARG Diamond — feature-rich base brand. */
export const argdiamond: BrandConfig = {
  id: 'argdiamond',
  name: 'ARG Diamond',
  displayName: 'ARG Diamond Club',
  title: 'ARG Diamond',
  colors: {
    // #0088cc  ->  hsl(201 100% 40%)
    primaryHsl: '201 100% 40%',
    primary: '#0088cc',
    headerGradient: ['#0a93d4', '#005f9e'],
    buttonGradient: ['#0a93d4', '#026aa5'],
  },
  features: {
    fantasy: true,
    aggregator: true,
    liveCasino: true,
    slots: true,
    downloadApk: true,
  },
  urls: {
    app: import.meta.env.VITE_APP_URL ?? 'http://localhost:3002',
  },
  supportEmail: 'info@argdiamond.com',
  assets: {
    // Background-free cut-out of images/logo/logo.jpg — the source has a solid
    // #1E6BC3 plate baked in, which shows as a box against the #0088cc header.
    logo: '/images/logo/logo-transparent.png',
    favicon: '/brands/argdiamond/favicon.ico',
    appleTouchIcon: '/brands/argdiamond/apple-touch-icon.png',
  },
};
